module.exports = __webpack_public_path__ + "resources/img/img_i_onenet_m_en.97a88596ce449e85859384edcbe7e622.png";